var Orientation;
(function (Orientation) {
    Orientation["HORIZONTAL"] = "h";
    Orientation["VERTICAL"] = "v";
    Orientation["UNKNOWN"] = "";
})(Orientation || (Orientation = {}));
function getBrowserOrientaton(thisWindow) {
    if (thisWindow.matchMedia) {
        return thisWindow.matchMedia('(orientation: portrait)').matches
            ? Orientation.VERTICAL
            : Orientation.HORIZONTAL;
    }
    return Orientation.UNKNOWN;
}
export class GlobalTrackingManagerV1 {
    constructor(environmentData, provider, breakPoints, window, navigationData) {
        this.environmentData = environmentData;
        this.provider = provider;
        this.breakPoints = breakPoints;
        this.window = window;
        this.navigationData = navigationData;
        this.breakPoints.sort((bp1, bp2) => bp1 - bp2);
    }
    track(eventAction, event, contextualData) {
        const eventInfo = Object.assign({ eventAction, pageId: this.getPageId() }, this.navigationData());
        const fullEvent = {
            environment: this.environmentData,
            user: this.createUserData(),
            eventInfo
        };
        if (contextualData) {
            eventInfo.featureAppId = contextualData.featureAppId;
            const eventData = contextualData.event;
            if (eventData) {
                Object.keys(eventData).forEach(key => {
                    const value = eventData[key];
                    if (value) {
                        const currentData = fullEvent[key];
                        if (!currentData) {
                            fullEvent[key] = value;
                        }
                        else {
                            fullEvent[key] = Object.assign(Object.assign({}, currentData), value);
                        }
                    }
                });
            }
        }
        Object.keys(event).forEach(key => {
            const value = event[key];
            const currentData = fullEvent[key];
            if (typeof value === 'object') {
                if (!currentData) {
                    fullEvent[key] = value;
                }
                else {
                    fullEvent[key] = Object.assign(Object.assign({}, currentData), value);
                }
            }
        });
        this.provider.push(fullEvent);
    }
    getPageId() {
        return `${this.window.location.host}${this.window.location.pathname}`;
    }
    createUserData() {
        return {
            browserResolutionBreakpoint: this.getBreakpoint(),
            browserResolutionHeight: this.window.screen.height.toString(),
            browserResolutionOrientation: getBrowserOrientaton(this.window),
            browserResolutionWidth: this.window.screen.width.toString()
        };
    }
    getBreakpoint() {
        // @ts-ignore
        if (this.window.matchMedia) {
            const matchingBps = this.breakPoints.filter((bp, idx) => {
                if (idx === this.breakPoints.length - 1) {
                    return this.matchMediaQuery(bp);
                }
                if (this.matchMediaQuery(bp, this.breakPoints[idx + 1])) {
                    return true;
                }
                return false;
            });
            if (matchingBps.length <= 0) {
                return '0';
            }
            return String(matchingBps[0]);
        }
        return '';
    }
    matchMediaQuery(minWidth, maxWidth) {
        if (!maxWidth) {
            return this.window.matchMedia(`screen and (min-width: ${minWidth}px)`)
                .matches;
        }
        return this.window.matchMedia(`screen and (max-width: ${maxWidth}px) and (min-width: ${minWidth}px)`).matches;
    }
}
export class ConsumerTrackingManagerV1Impl {
    constructor(delegate) {
        this.delegate = delegate;
    }
    track(action, event) {
        this.delegate.track(action, event, this.contextualEventData);
    }
}
